import { gql } from 'graphql-request';

import type { Pagination } from '@/hooks/use-pagination';

interface Faqs {
  id: string;
  category: string;
  question: string;
  answer: string;
}

export const createFaqsListQuery = () => gql`
  query getFaqsList(
    $searchTerm: String
    $category: String
    $limit: Int!
    $page: Int
  ) {
    searchFaqs(
      searchTerm: $searchTerm
      category: $category
      limit: $limit
      page: $page
    ) {
      totalDocs
      page
      docs {
        id
        category {
          name
        }
        order
        question
        answer
      }
    }
  }
`;

export const mapSingle = (data: any): Faqs => {
  return {
    id: data.id,
    category: data.category.name,
    question: data.question,
    answer: data.answer,
  };
};

export const mapToFaqsList = (data: any): Faqs[] => {
  return data?.searchFaqs?.docs.map(mapSingle);
};

export const mapToPaginatedFaqsList = (data: any): Pagination<Faqs> => {
  const docs = data.searchFaqs.docs.map(mapSingle);

  return {
    total: data.searchFaqs.totalDocs,
    page: data.searchFaqs.page,
    docs,
  };
};
